function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import Tooltip from '@shared/components/tooltip';
import { DirectionalHint, Stack, Text, Spinner, SpinnerSize } from '@fluentui/react';
import { AppTileLinkedItems } from '@shared/components/appTileLinkedItems';
import { logger } from '@src/logger';
import { Constants } from '@shared/utils/constants';
import { ItemsContainerComponent } from '@shared/components/itemsContainer';
import { getAppRelatedAppsItems } from '@shared/services/http/entityRestClient';
const tooltipHostStyles = {
    root: {
        overflow: 'hidden',
        display: 'inline-block'
    }
};
const stackContainerTokens = {
    childrenGap: 8
};
const textSize = 'smallPlus';
const maxTooltipWidth = 450;
const calloutProps = {
    isBeakVisible: true,
    gapSpace: 6
};
export const ItemsTooltip = ({ children, title, linkedItemsIds, items, parentItem })=>{
    const [linkedItemsData, setLinkedItemsData] = useState([]);
    const getLinkedAppDataItems = ()=>_async_to_generator(function*() {
            const items = yield getAppRelatedAppsItems(parentItem.entityId, '');
            if (items.saasLinkingItems.length) {
                setLinkedItemsData(items.saasLinkingItems);
            }
            if (items.linkedAddIns.length) {
                setLinkedItemsData(items.linkedAddIns);
            }
        })();
    const toolipToggled = (isTooltipVisible)=>{
        const { title, entityId } = parentItem;
        if (isTooltipVisible) {
            const payload = {
                page: location.pathname,
                action: Constants.Telemetry.Action.Hover,
                actionModifier: Constants.Telemetry.ActionModifier.SaasLinkTooltip,
                details: JSON.stringify({
                    title,
                    entityId
                })
            };
            logger.info('', payload);
            if (!(linkedItemsData === null || linkedItemsData === void 0 ? void 0 : linkedItemsData.length) && (linkedItemsIds === null || linkedItemsIds === void 0 ? void 0 : linkedItemsIds.length)) {
                getLinkedAppDataItems();
            }
        }
    };
    const renderAppTileLinkedItem = ()=>{
        return (linkedItemsData === null || linkedItemsData === void 0 ? void 0 : linkedItemsData.length) ? /*#__PURE__*/ _jsx(AppTileLinkedItems, {
            title: title,
            linkedItems: linkedItemsData,
            hoveredItem: parentItem
        }) : /*#__PURE__*/ _jsx(Spinner, {
            size: SpinnerSize.large
        });
    };
    return (linkedItemsIds === null || linkedItemsIds === void 0 ? void 0 : linkedItemsIds.length) || (items === null || items === void 0 ? void 0 : items.length) ? /*#__PURE__*/ _jsx(Tooltip, {
        onTooltipToggle: (linkedItemsIds === null || linkedItemsIds === void 0 ? void 0 : linkedItemsIds.length) ? toolipToggled : null,
        tooltipHostProps: {
            tooltipProps: {
                onRenderContent: ()=>(linkedItemsIds === null || linkedItemsIds === void 0 ? void 0 : linkedItemsIds.length) ? renderAppTileLinkedItem() : (items === null || items === void 0 ? void 0 : items.length) ? /*#__PURE__*/ _jsxs(Stack, {
                        tokens: stackContainerTokens,
                        children: [
                            title && /*#__PURE__*/ _jsx(Text, {
                                variant: textSize,
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(ItemsContainerComponent, {
                                items: items,
                                withText: true,
                                wrap: true,
                                textSize: textSize,
                                withDivider: false
                            })
                        ]
                    }) : null,
                maxWidth: `${maxTooltipWidth}px`
            },
            calloutProps,
            styles: tooltipHostStyles,
            directionalHint: (linkedItemsIds === null || linkedItemsIds === void 0 ? void 0 : linkedItemsIds.length) ? DirectionalHint.rightCenter : DirectionalHint.topCenter
        },
        children: children
    }) : null;
};
